import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";



export var activateTutorForCourses = function(userId, courses, instanceId, targetField, btn=false){

    const url = '/instance/' + instanceId.toString() + '/tutor/' + userId.toString() + '/invite'

    const success = function (data){
        $(".close-tutor-act").click();
        //fillBadges(userId, targetField, schoolId);
        successToast(courses.length + " Kurs(e) wurde zu Tutor/-in hinzugefügt","Erfolg", 6500, true);
        setTimeout(() => {
            location.reload();
        }, 1250)
    }

    const data = {
        courses: courses
    }

    return ajaxRequest(url, success, data, btn);

}